import styled from "styled-components";

export const StyledHeader = styled.header`
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 1000;

  .container {
    max-width: 1200px;
    width: 90%;
  }
  nav {
    display: flex;
    justify-content: flex-end;
    button {
      border: none;
      background: transparent;
      font-size: 16px;
      color: #999;
      transition: color 1s;
      margin-right: 4vw;
    }

    button:hover {
      color: black;
    }
  }
`;
